import { request } from 'utils/request';

import { errorFromException } from 'errors';
import * as Types from 'types';

import { TransactionableTypes } from './index';

type Response = {
  payment_intent: Pick<stripe.paymentIntents.PaymentIntent, 'client_secret'>;
};

type StripeMethodTypes = 'automatic' | 'manual';

export const createTransaction = async (
  transactionable: TransactionableTypes,
  transactionablePublicId: string,
  paymentMethodId: string,
  options?: {
    confirmationMethod?: StripeMethodTypes;
    captureMethod?: StripeMethodTypes;
  },
): Promise<Types.ApiResult<Response>> => {
  try {
    const { data } = await request.post<Response>(
      `/api/internal/${transactionable}/${transactionablePublicId}/transactions`,
      {
        payment_intent: {
          payment_method: paymentMethodId,
          confirmation_method: options?.confirmationMethod,
          capture_method: options?.captureMethod,
        },
      },
    );
    return { data, error: undefined };
  } catch (e) {
    return errorFromException(e, 'Unable to create transaction');
  }
};
